function expandMenu(){
  var expandedMenu = document.getElementById("expandedMenu");
  document.getElementById("menuIcon").addEventListener("click", () => {    
    var menuIcon = document.querySelector(".svgIcon-menu path");
    var menuText = document.getElementById("menuIcon");
    const l1Menu = expandedMenu.querySelector(".l1-menu");
    const backBtn = expandedMenu.querySelector(".back_menu-btn");
    expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
      openDetail.removeAttribute("open");
    });
        // Mobile View Menu
        if(expandedMenu.offsetWidth != 0){
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="none";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="none";
            expandedMenu.style.width = "0";
            menuIcon.style.fill = "#fff";
            menuIcon.setAttribute("fill-rule", "evenodd");
            document.body.classList.remove('menu-expanded');
            menuText.getElementsByClassName('icon-label')[0].style.color="#fff";
            document.getElementById("modal-overlay_mob").style.display = "none";
            document.getElementById("modal-overlay_mob").style.zIndex = "-1";
            document.body.style.overflow = ''; 
        }else{
            window.scrollTo(0, 0);
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="block";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="block";
            expandedMenu.style.width = "100%";
            document.body.style.overflow = 'hidden';
            document.body.classList.add('menu-expanded');
            menuIcon.style.fill = "#FFD900";
            menuIcon.setAttribute("fill-rule", "nonzero");
            menuText.getElementsByClassName('icon-label')[0].style.color="#FFD900";
            document.getElementById("modal-overlay_mob").style.display = "block";
            document.getElementById("modal-overlay_mob").style.zIndex = "5";
          
          expandedMenu.querySelectorAll(".l1-menu-item-wrapper").forEach(wrapper => {
            const summary = wrapper.querySelector("summary");
            if (summary) {
              summary.addEventListener("click", () => {
                setTimeout(() => {
                  if (wrapper.hasAttribute("open")) {
                    backBtn.style.visibility = "visible";
                  }
                }, 0); // wait for native toggle
              });
            }
          });
        
          backBtn.addEventListener("click", () => {            
             expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
                openDetail.removeAttribute("open");
              });
            backBtn.style.visibility = "hidden";
          });
        }
        expandedMenu.querySelector('.close_menu-btn').addEventListener("click", () => {
          expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
            openDetail.removeAttribute("open");
          });
          // Hide back button if it’s visible
          backBtn.style.visibility = "hidden";
          expandedMenu.classList.remove("mobile-menu_open");
          expandedMenu.classList.add("mobile-menu_close");
          expandedMenu.style.width = "0";
          menuIcon.style.fill = "#fff";
          menuIcon.setAttribute("fill-rule", "evenodd");        
          menuText.getElementsByClassName('icon-label')[0].style.color="#fff";
          document.getElementById("modal-overlay_mob").style.display = "none";
          document.body.style.overflow = ''; 
          document.body.classList.remove('menu-expanded');
          document.getElementById("modal-overlay_mob").style.zIndex = "-1";
          expandedMenu.getElementsByClassName("menu-header")['0'].style.display="none";
          expandedMenu.getElementsByClassName("menu-body")['0'].style.display="none";
        });
}); 
  expandedMenu.querySelectorAll('.l2-menu details').forEach(detailsEl => {
    detailsEl.addEventListener('toggle', function () {
      if (this.open) {      
        const siblings = this.parentElement.querySelectorAll('details');
        siblings.forEach(sibling => {
          if (sibling !== this && sibling.open) {
            sibling.removeAttribute('open');
          }
        });
      }
    });
  });
}
function stickyHeaderOnScroll() {
    var header = document.getElementsByClassName("desktop-header")[0];
    var textLogo = document.getElementById("textLogo");
    var iconLogo = document.getElementById("iconLogo");
    
    if (header) {
        window.onscroll = function() {
            var sticky = header.offsetTop;

            if (window.pageYOffset > sticky) {
                textLogo.style.opacity = "0";
                iconLogo.style.opacity = "1";
            } else {
                textLogo.style.opacity = "1";
                iconLogo.style.opacity = "0";
            }
        };
    }
}
expandMenu();
stickyHeaderOnScroll();